// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__y8TMZ","list":"PatternAutocomplete_list__1wx1o"};